export const REQUIRED_PROFILE_FIELDS = [
  ['industry', '行业'], ['position', '岗位'], ['ai_usage_purpose', 'AI 使用目的'],
];

export function missingProfileFields(profile) {
  return REQUIRED_PROFILE_FIELDS.filter(([key]) => !String(profile?.[key] || '').trim())
    .map(([, label]) => label);
}
